import React, {useMemo, useState} from "react";
import {Font} from "../../../../types/Font";
import {useGlobalContext} from "../../../../contexts/globalContext";
import Text from "../../../../components/Text";
import Input from "../../../../components/Input";
import Button from "../../../../components/Button";
import styles from './NewFontModalContent.module.css'
import cx from "classnames";
import {faChevronDown, faChevronRight} from "@fortawesome/free-solid-svg-icons";
import Icon from "../../../../components/Icon";
import {useTranslation} from "react-i18next";
import {useStoreData} from "../../../../hooks/useStoreData";
import * as yup from "yup";
import DropInput from "../../../../components/DropInput";

const NewFontModalContent: React.FC<{fonts: Font[], onSubmit: () => void}> = ({fonts, onSubmit}) => {
    const {closeModal, showToast} = useGlobalContext()
    const [showWebsafe, setShowWebsafe] = useState<boolean>(false)
    const { t } = useTranslation(['settings'])

    const storeFontSchema = useMemo(() => {
        return ({
            name: yup.string().required().min(3).notOneOf(fonts.map(f => f.name)),
        })
    },[fonts])

    const {
        element,
        changeProp,
        changeFile,
        submit,
        isValid,
        clearData,
        error
    } = useStoreData<Font>('fonts', storeFontSchema)

    const handleSubmit = () => {
        if (error) {
            showToast('top-right', 'error', error)
        } else if (isValid) {
            submit().then((res) => {
                if (res.status === 201) {
                    clearData()
                    closeModal()
                    showToast('top-right', 'success', t('fonts.create_modal.success'))
                } else {
                    showToast('top-right', 'error', t('fonts.create_modal.error'))
                }
                onSubmit()
            })
        }
    }

    return (
        <div className={cx(styles['modal-wrapper'])}>
            <div className={'w-100'}>
                <Text>{t('fonts.create_modal.sub_heading')}</Text>
            </div>
            <Input
                type={'text'}
                placeholder={t('fonts.labels.name')}
                property={'name'} value={element.name ?? ''}
                onChange={(property, value) => changeProp({name: value})}
                classes={'my-3'}
            />
            <div className={cx(styles['websafe-header'])} onClick={() => setShowWebsafe(prev => !prev)}>
                <Text>{t('fonts.websafe.heading')}</Text>
                <Icon icon={showWebsafe ? faChevronDown : faChevronRight} color={'black'}  size={'sm'}/>
            </div>
            <div className={cx(styles['websafe-wrapper'])} style={{maxHeight: !showWebsafe ? '0px' : '100vh'}}>
                {t('fonts.websafe.content')}
            </div>
            <div className={cx(styles['upload-label'])}>
                {t('fonts.labels.file')}
            </div>
            <div className={'w-100'}>
                <DropInput accept={".ttf,.woff,.woff2"} onFileChange={(file) => changeFile(file)}/>
            </div>
            <Button
                hierarchy={'primary'}
                text={t('fonts.create_modal.action')}
                fn={() => handleSubmit()}
                classes={'w-100 mx-4'}
                disabled={!isValid}
            />
        </div>
    )
}

export default NewFontModalContent
